// extracted by mini-css-extract-plugin
export default {"root":"RcpXo","shadow":"JgMdW","secondary":"XGCts","animationContainer":"in9Pb","heart":"ybS0A","floatAway":"tQKfp","hearts":"kDh_l"};